<template>
	<!-- 设置 -->
	<div class="setBox">
		<!-- 头部 -->
		<van-sticky>
			<div class="headerBox">
				<div class="headerQuery">
					<div class="arrImg" @click="back">
						<img src="../../assets/img/leftarr_tit.png" alt="">
					</div>
					<p class="header_titile">设置</p>
				</div>
			</div>
		</van-sticky>
		<div class="setType setTypeFirstBox">
			<router-link tag="div" to="/xgpassword" class="setTypeItem">
				<p class="setTypeLeft">修改密码</p>
				<div class="setTypeRight">
					<img src="../../assets/img/rightArr.png" alt="">
				</div>
			</router-link>
			<router-link to="/zfmima" tag="div" class="setTypeItem">
				<p class="setTypeLeft">支付密码设置</p>
				<div class="setTypeRight">
					<img src="../../assets/img/rightArr.png" alt="">
				</div>
			</router-link>
			<router-link tag="div" to="/yjfk" class="setTypeItem">
				<p class="setTypeLeft">意见反馈</p>
				<div class="setTypeRight">
					<img src="../../assets/img/rightArr.png" alt="">
				</div>
			</router-link>
			<router-link tag="div" to="/cjwt" class="setTypeItem">
				<p class="setTypeLeft">常见问题</p>
				<div class="setTypeRight">
					<img src="../../assets/img/rightArr.png" alt="">
				</div>
			</router-link>
			<router-link tag="div" to="/aboutYj" class="setTypeItem">
				<p class="setTypeLeft">关于云锦</p>
				<div class="setTypeRight">
					<img src="../../assets/img/rightArr.png" alt="">
				</div>
			</router-link>
			<router-link tag="div" to="/registXy" class="setTypeItem">
				<p class="setTypeLeft">注册协议</p>
				<div class="setTypeRight">
					<img src="../../assets/img/rightArr.png" alt="">
				</div>
			</router-link>
			<router-link tag="div" to="/privacyAgreement" class="setTypeItem">
				<p class="setTypeLeft">隐私协议</p>
				<div class="setTypeRight">
					<img src="../../assets/img/rightArr.png" alt="">
				</div>
			</router-link>
			<!-- <router-link tag="div" to="/xtsz" class="setTypeItem">
				<p class="setTypeLeft">系统设置</p>
				<div class="setTypeRight">
					<img src="../../assets/img/rightArr.png" alt="">
				</div>
			</router-link> -->

		</div>

		<div class="setType" style="margin-bottom: 30px;">
			<div class="xtszListItem">
				<span>青少年模式</span>
				<div>
					<van-switch v-model="checkedYoung" size="20px" active-color="#07c160" inactive-color="#ffffff" @change="checkedYoungFn(checkedYoung)"/>
				</div>
			</div>
			<div class="xtszListItem">
				<span>消息推送</span>
				<div>
					<van-switch v-model="checked" size="20px" active-color="#07c160" inactive-color="#ffffff" />
				</div>
			</div>
			<div class="setTypeItem">
				<p class="setTypeLeft">同步</p>
				<div class="setTypeRight">
				</div>
			</div>
			<div class="setTypeItem" @click="clearCache">
				<p class="setTypeLeft">清除缓存</p>
				<div class="setTypeRight">
					<span>{{cache}}</span>
				</div>
			</div>
			<div class="setTypeItem">
				<p class="setTypeLeft">版本更新</p>
				<div class="setTypeRight">
					<span>{{version}}</span>
				</div>
			</div>
			<div class="setTypeItem" @click="go_chatPage">
				<p class="setTypeLeft">账号注销</p>
				<div class="setTypeRight" >
					<span style="font-size: 12px;color: grey">点击进入后描述您的问题，如：申请账号注销</span>
				</div>
			</div>
		</div>
		<div class="fixed_tc_login">
			<div class="tc_login" @click='closeLogin'>
				<img src="../../assets/img/flower.png" alt="">
				<button>退出登录</button>
			</div>
		</div>
	</div>
</template>


<script>
	import {Toast,Dialog} from 'vant'
	export default {
		data() {
			return {
				checkedYoung: false,
				checked:true,
				userInfoData:{},
				cache: 0,
				version:'0.0.0',//版本号
			}
		},
		created() {
			this.$axios.post(this.$api.my_info).then(res => {
				if(res.data.code ==1){
					this.checkedYoung = Boolean(res.data.data.is_young);
				}
			})
			if (this.$webapp.isAndroid) {
				console.log("安卓")
				this.cache = window.android.getTotalCache(); //安卓-- 获取缓存
				this.version = window.android.getappVersion();//版本号
			} else if (this.$webapp.isiOS) {
				console.log("苹果")
				// window.webkit.messageHandlers.loginwx.postMessage('') // 苹果
			}
			this.userInfoData = JSON.parse(localStorage.getItem('userInfoData'));
		},
		methods: {
			onInput(checked) {
				Dialog.confirm({
					title: '提醒',
					message: '是否切换开关？',
				}).then(() => {
					this.checked = checked;
				});
			},
      go_chatPage(numMassage,content) {
        this.$router.push({path:'/chatlist',query:{numMassage:8,newest_msg:''}});
      },

			// 青少年模式
			checkedYoungFn(checkedYoungFn){
				this.checkedYoung = checkedYoungFn;
				
				if(checkedYoungFn == true){
					Dialog.confirm({
							title: '云锦文学城青少年模式功能使用声明',
							message: `一、为呵护未成年人健康成长、行业履行社会责任、营造良好网络环境，云锦文学城提供“青少年模式”供用户选择，进入“青少年模式”后，用户的充值功能将受到限制。<br/>二、防止青少年沉迷网络，既需要互联网企业认真履行社会责任，也需要社会各界共同努力，特别是学校和学生家长的密切配合。云锦文学城呼吁未成年用户家长关注用户的浏览时间、作者的写作内容，在遇到违法或不良内容时可向云锦文学城平台举报，平台将受理、协助处置平台中的不良内容内容，主动承担保护和引导青少年正确使用网络平台的责任，为青少年健康成长创造良好的网络空间。<br/><br/>用户阅读后选择是否开启青少年模式。
							`,
						})
						.then(() => {
							this.$axios.post(this.$api.set_young).then(res => {
								Toast(res.data.msg)
							})
						})
						.catch(() => {
							// on cancel
						});
					
				}else if(checkedYoungFn == false){
					Dialog.confirm({
							// title: '',
							message: '取消设置青少年模式',
						})
						.then(() => {
							this.$axios.post(this.$api.cancel_young).then(res => {
								Toast(res.data.msg)
							})
						})
						.catch(() => {
							// on cancel
						});
				}
			},
			back() {
				this.$router.push('/userinfo')
			},
			closeLogin() {
				Toast('操作成功')
				this.$store.commit('loginUserImgFn', require("@/assets/tabbar/userimg.png"))
				localStorage.removeItem('userInfo');
				localStorage.removeItem('userInfoData');
				// sessionStorage.clear();
				this.$router.push('/userinfo');
			},
			clearCache(){
				if (this.$webapp.isAndroid) {
					console.log("安卓")
					this.cache = window.android.clearCache(); //安卓 -- 设置亮度
				} else if (this.$webapp.isiOS) {
					console.log("苹果")
					// window.webkit.messageHandlers.loginwx.postMessage('') // 苹果
				}
				
			}
			
		}
	}
</script>

<style scoped lang="less">
	.setBox {
		background-color: #fff;
		height: 100vh;
		color: #000;
		// 头部
		.headerBox {
			height: 160px;
			background-color: #ff4d8a;
			display: flex;
			background: url(../../assets/img/myicon/indexBgc.png) no-repeat 0% 88% #fff;
			background-size: 100%;
			border-bottom: 1px solid #f0f0f0;/*no*/
			.headerQuery {
				margin-top: 80px;
				padding: 0 16px;
				position: relative;
				display: flex;
				width: 100%;
				height: 90px;
				line-height: 90px;
				color: #000;

				.arrImg {
					img {
						width: 40px;
						position: absolute;
						top: 50%;
						transform: translateY(-50%);
						left: 0px;
					}
				}

				.header_titile {
					flex: 1;
					text-align: center;
					font-size: 34px;
					/*px*/
				}
			}

		}

		//
		.setType {
			background-color: #fff;
			// padding-bottom: 20px;
			padding: 0 16px;

			.xtszListItem {
				border-bottom: 1px solid #f0f0f0;
				/*no*/
				display: flex;
				line-height: 90px;

				span,
				div {
					flex: 1;
					font-size: 33px;
					/*px*/
				}

				>div {
					text-align: right;
					position: relative;

					.van-switch {
						position: absolute;
						top: 50%;
						right: 0;
						transform: translateY(-50%);
					}
				}
			}

			.setTypeItem {
				border-bottom: 1px solid #f0f0f0;
				/*no*/
				height: 90px;
				line-height: 90px;
				display: flex;
				position: relative;

				.setTypeLeft {
					flex: 1;
					font-size: 33px;
					/*px*/
					color: #000000;
				}

				.setTypeRight {
					height: 84px;

					img {
						height: 60px;
						position: absolute;
						top: 50%;
						right: -10px;
						transform: translateY(-50%);
						width: 50px;
						height: 50px;
					}
					span{
						font-size: 34px;/*px*/
					}
				}
			}
		}

		.setType.setTypeFirstBox {
			border-bottom: 5px solid #f0f0f0;
			/*no*/
		}

		//denglu
		.fixed_tc_login {
			//position: fixed;
			//bottom: 5%;
			//left: 0;
			width: 100vw;

			.tc_login {
				text-align: center;
				// margin: 150px 0;
				position: relative;

				img {
					position: absolute;
					top: -60px;
					left: 15%;
					width: 100px;
				}

				button {
					width: 90%;
					background-color: #ff4081;
					color: #fff;
					border: 0;
					line-height: 80px;
					border-radius: 10px;
					font-size: 32px;
					/*px*/
				}
			}
		}

	}
</style>
